"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _StudioReadinessSpkrTest = _interopRequireDefault(require("./StudioReadinessSpkrTest.mp3"));
var _ReadinessCheck = require("./ReadinessCheck.styled");
var SampleAudio = function SampleAudio() {
  return /*#__PURE__*/_react["default"].createElement(_ReadinessCheck.StyledAudio, {
    src: _StudioReadinessSpkrTest["default"],
    autoPlay: true,
    loop: true
  });
};
var _default = exports["default"] = SampleAudio;